import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { Box } from '../../foundation/Box/index.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { AvatarWithLabel } from '../../dataDisplay/AvatarWithLabel/AvatarWithLabel.js';
import { IconWithLabel } from '../../dataDisplay/IconWithLabel/IconWithLabel.js';

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var avatarSizes = {
  small: 'lg',
  medium: '2xl'
};
function EmptyState(props) {
  var icon = props.icon,
    title = props.title,
    description = props.description,
    actions = props.actions,
    className = props.className,
    _props$size = props.size,
    size = _props$size === void 0 ? 'medium' : _props$size,
    withAvatar = props.withAvatar,
    _props$px = props.px,
    px = _props$px === void 0 ? 'md' : _props$px,
    rest = __rest(props, ["icon", "title", "description", "actions", "className", "size", "withAvatar", "px"]);
  var flexDirection = size === 'small' ? 'column' : 'row';
  var gap = size === 'small' ? 'lg' : 'xl';
  return /*#__PURE__*/jsxs(Box, _extends({
    className: className,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "3xl",
    py: "7xl",
    px: px
  }, rest, {
    children: [withAvatar ? /*#__PURE__*/jsx(AvatarWithLabel, {
      alignment: "vertical",
      appearance: "secondary",
      size: avatarSizes[size],
      title: title,
      subtitle: description,
      truncate: false,
      children: icon
    }) : /*#__PURE__*/jsx(IconWithLabel, {
      alignment: "vertical",
      size: avatarSizes[size],
      title: title,
      subtitle: description,
      truncate: false,
      children: icon
    }), actions && /*#__PURE__*/jsx(Box, {
      flexDirection: flexDirection,
      gap: gap,
      children: actions
    })]
  }));
}

export { EmptyState };
